"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Button = void 0;

var _react = _interopRequireDefault(require("react"));

var _atoms = require("../atoms");

var _reactRouterDom = require("react-router-dom");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

/**
 * Button
 *
 * @component
 * @category Molecules
 */
var Button = function Button(props) {
  var onClick = function onClick(e) {
    if (!props.disabled && props.onClick) {
      props.onClick(e);
    }
  };

  var useRow = true; // Content

  var content;

  if (typeof props.content === "string") {
    content = /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: props.content
    });
  } else {
    content = props.content;
  } // Padding


  var spaceLeft = 8;
  var spaceRight = 8;
  var spaceTop = 4;
  var spaceBottom = 4; // Class Name

  var className = "Button";

  if (props.className) {
    className += " " + props.className;
  }

  if (props.small) {
    className += " small";
    spaceLeft = 6;
    spaceRight = 6;
    spaceTop = 2;
    spaceBottom = 2;
  }

  if (props.primary) {
    className += " primary";
  }

  if (props.ghost) {
    className += " ghost";
  }

  if (props.disabled) {
    className += " disabled";
  }

  if (props.narrow) {
    spaceLeft = 1;
    spaceRight = 1;
    spaceTop = 1;
    spaceBottom = 1;
  }

  if (props.icon) {
    className += " icn";
    spaceLeft = 0;
    spaceRight = 0;
    spaceTop = 0;
    spaceBottom = 0;
    useRow = false;
    var iconSize = props.iconSize ? props.iconSize : 24;
    var iconColor = props.iconColor ? props.iconColor : "";
    content = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_atoms.Icon, {
      size: iconSize,
      type: props.icon,
      color: iconColor
    }), props.content && /*#__PURE__*/_react.default.createElement(_atoms.Label, {
      type: _atoms.Label.Type.InnerButton,
      content: props.content
    }));
  } // Tag Name


  var tag = "button";

  if (props.href) {
    tag = "a";
  }

  var styles = props.styles ? Object.assign({}, props.styles) : {};
  styles.justifyContent = props.justifyContent ? props.justifyContent : "center";
  styles.alignItems = props.alignItems ? props.alignItems : "center";

  if (props.alignConent) {
    styles.alignContent = props.alignContent;
  }

  if (props.flexDirection) {
    styles.flexDirection = props.flexDirection;
  }

  var attr = Object.assign({}, props, {
    className: null,
    content: null,
    primary: null,
    ghost: null,
    small: null,
    icon: null,
    iconSize: null,
    iconColor: null,
    narrow: null
  });

  if (attr.onClick) {
    attr.onClick = onClick;
  }

  var link = tag === "a" && !props.href.startsWith("mailto") && !props.href.startsWith("http") && props.link !== false;
  return /*#__PURE__*/_react.default.createElement(_atoms.Element, _extends({}, attr, {
    link: link,
    className: className,
    style: styles,
    tag: tag
  }), /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    center: true,
    type: useRow ? _atoms.Stack.Type.Row : _atoms.Stack.Type.Column,
    spacingLeft: spaceLeft,
    spacingRight: spaceRight,
    spacingTop: spaceTop,
    spacingBottom: spaceBottom
  }, content));
};

exports.Button = Button;